export const validateSlide = (index, slidesLength) => {
    let isValid = false;
    if ((index > -1) && (index < slidesLength)) {
        isValid = true;
    }
    return isValid;
};
export const onSwipeRight = (activeSlide, slidesLength) => {
    const nextSlide = activeSlide - 1;
    if (validateSlide(nextSlide, slidesLength)) {
        return nextSlide;
    }
    return activeSlide;
};
export const onSwipeLeft = (activeSlide, slidesLength) => {
    if (validateSlide(activeSlide + 1, slidesLength)) {
        return (activeSlide + 1);
    }
    return 0;
};
export const applyTransition = (activeSlide, className, interItemSpace = {}, carouselType = '', transitionDuration = 0.5) => {
    if (document) {
        const elemArray = Array.from(document.getElementsByClassName(className));
        if (elemArray && elemArray.length) {
            const { clientWidth } = elemArray[0];
            const numberPattern = /\d+/g;
            let transitionSpace = 0;
            if (interItemSpace && interItemSpace.web) {
                transitionSpace = +interItemSpace.web.match(numberPattern).join('.');
            }
            if (clientWidth) {
                const transTime = transitionDuration;
                let style = `transition: transform ${transTime}s ease;transform: translateX(-${((clientWidth + (transitionSpace * 16)) * activeSlide)}px)`;
                if (carouselType === 'edgetoedge') {
                    style = `transition: transform ${transTime}s ease;transform: translateX(-${((clientWidth) * activeSlide)}px)`;
                }
                [].forEach.call(elemArray, (element) => {
                    element.setAttribute('style', style);
                });
            }
        }
    }
};
